export default (MAP_MESSAGES: any, defaultMessage: any) =>
  (key: string | number) =>
    MAP_MESSAGES[key] || defaultMessage;
